import { render, staticRenderFns } from "./NewOrders.vue?vue&type=template&id=73085a94&scoped=true"
import script from "./NewOrders.vue?vue&type=script&lang=js"
export * from "./NewOrders.vue?vue&type=script&lang=js"
import style0 from "./NewOrders.vue?vue&type=style&index=0&id=73085a94&prod&scoped=true&lang=less"
import style1 from "./NewOrders.vue?vue&type=style&index=1&id=73085a94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73085a94",
  null
  
)

export default component.exports